// saga.js
import { call, put, takeLatest } from 'redux-saga/effects'

import {
  FETCH_USERS_REQUEST,
  ADD_USER_REQUEST,
  UPDATE_USER_REQUEST,
  DELETE_USER_REQUEST,
  FETCH_PENDING_VENDORS_REQUEST,
  APPROVE_VENDOR_REQUEST,
} from './actionTypes'
import {
  fetchUsersSuccess,
  fetchUsersFailure,
  addUserSuccess,
  addUserFailure,
  updateUserSuccess,
  updateUserFailure,
  deleteUserSuccess,
  deleteUserFailure,
  fetchPendingVendorsSuccess,
  fetchPendingVendorsFailure,
  approveVendorSuccess,
  approveVendorFailure,
} from './actions'
import axiosInstance from 'pages/Utility/axiosInstance'
import toast from 'react-hot-toast'
import { showSuccess, showError } from 'helpers/notification_helper'
import * as url from 'helpers/url_helper'

// API calls
const fetchUsersApi = async () => {
  return await axiosInstance.get('V1/users')
}

const addUserApi = async (user) => {
  return await axiosInstance.post('V1/users', user)
}

const updateUserApi = async ({id,user}) => {
  return await axiosInstance.put(`V1/users/${id}`, user)
}

const deleteUserApi = async (userId) => {
  return await axiosInstance.delete(`V1/users/${userId}`)
}

// Fetch users
function* fetchUsersSaga(action) {
  try {
    const response = yield call(fetchUsersApi,action.payload)
    yield put(fetchUsersSuccess(response.data))
  } catch (error) {
    yield put(fetchUsersFailure(error.message))
  }
}

// Fetch pending vendors
function* fetchPendingVendorsSaga() {
  try {
    const response = yield call(() => axiosInstance.get(url.GET_PENDING_VENDORS))
    yield put(fetchPendingVendorsSuccess(response.data))
  } catch (error) {
    yield put(fetchPendingVendorsFailure(error.message))
  }
}

// Approve vendor
function* approveVendorSaga(action) {
  try {
    yield call(putApproveVendorApi, action.payload)
    yield put(approveVendorSuccess(action.payload))
    showSuccess('Vendor approved successfully!')
  } catch (error) {
    yield put(approveVendorFailure(error.message))
    showError(error.message || 'Failed to approve vendor')
  }
}

const putApproveVendorApi = async (id) => {
  return await axiosInstance.put(`V1/users/${id}/approve`)
}

// Add user
function* addUserSaga(action) {
  try {
    const response = yield call(addUserApi, action.payload.user);
    action.payload.onClose();
    yield put(addUserSuccess(response.data))
    showSuccess('User added successfully!')
  } catch (error) {
    yield put(addUserFailure(error?.response?.data?.errors))
  }
}

// Update user
function* updateUserSaga(action) {
  try {
    const response = yield call(updateUserApi, action.payload)
    showSuccess(response?.data?.message)
    action.payload.onClose();
    yield put(updateUserSuccess(response?.data))
  } catch (error) {
    yield put(updateUserFailure(error?.response?.data?.errors))
  }
}

// Delete user
function* deleteUserSaga(action) {
  try {
    const {data} = yield call(deleteUserApi, action.payload)
    yield put(deleteUserSuccess(data))
    showSuccess('User Deleted successfully!')
  } catch (error) {
    yield put(deleteUserFailure(error.message))
  }
}

// Watcher saga
export default function* userSaga() {
  yield takeLatest(FETCH_USERS_REQUEST, fetchUsersSaga)
  yield takeLatest(FETCH_PENDING_VENDORS_REQUEST, fetchPendingVendorsSaga)
  yield takeLatest(APPROVE_VENDOR_REQUEST, approveVendorSaga)
  yield takeLatest(ADD_USER_REQUEST, addUserSaga)
  yield takeLatest(UPDATE_USER_REQUEST, updateUserSaga)
  yield takeLatest(DELETE_USER_REQUEST, deleteUserSaga)
}
